import React, { useEffect, useState } from "react";
import { Alert, Col, Container, Row } from "reactstrap";

import Header from "./Header";
import MainDetails from "./MainDetails";
import AdditionalDetails from "./AdditionalDetails";
import { useParams, useLocation } from "react-router-dom";
import { usePageActivity } from "Components/Hooks/UsePageActivity";
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import { getUNGMItem as onGetUNGMItem } from "slices/thunks";
import BreadCrumb from "Components/Common/BreadCrumb";

const ViewUNGMItem = () => {
  const location = useLocation();
  const dispatch: any = useDispatch();

  const { id: itemId } = useParams();
  usePageActivity(location.pathname, "View UNGM Debarred List", itemId);

  useEffect(() => {
    dispatch(onGetUNGMItem(itemId));
  }, [itemId, dispatch]);

  const selectLayoutState = (state: any) => state.SanctionsList;
  const selectProperties = createSelector(selectLayoutState, (state) => ({
    ungmItem: state.ungmItem,
  }));

  const { ungmItem } = useSelector(selectProperties);

  const [isWorldBankItem, setIsWorldBankItem] = useState(false);
  useEffect(() => {
    if (ungmItem.dataSource === "World Bank") {
      setIsWorldBankItem(true);
    } else {
      setIsWorldBankItem(false);
    }
  }, [ungmItem.dataSource]);

  document.title = "UNGM Debarred Item | CIMS";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {isWorldBankItem ? (
            <BreadCrumb
              title="World Bank Sanction Details"
              pageTitles={[
                {
                  title: "Dashboard",
                  link: "/",
                },
                {
                  title: "World Bank Debarred List",
                  link: "/sanctions-list/world-bank",
                },
              ]}
              back
            />
          ) : (
            <BreadCrumb
              title="UNGM Sanction Details"
              pageTitles={[
                {
                  title: "Dashboard",
                  link: "/",
                },
                { title: "UNGM Debarred List", link: "/sanctions-list/ungm" },
              ]}
              back
            />
          )}
          <Row>
            <Col>
              <Alert color="danger" className="material-shadow">
                <strong> UNGM Ineligibility List! </strong> This entity appears
                in the UNGM Ineligibility List. Please check the profile below
                for more information.
              </Alert>
            </Col>
          </Row>
          <Row>
            <Header data={ungmItem} />
          </Row>
          <Row>
            <MainDetails data={ungmItem} />
            <AdditionalDetails data={ungmItem} />
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ViewUNGMItem;
